module.exports = __webpack_public_path__ + "assets/img/383d-je.svg";